import { EnumValues } from './EnumValues';

export interface IRequestXeroConnectionResponse {
  url: string;
}

export interface ICreateXeroConnectionRequest {
  code: string;
  secret: string;
}

export const XeroConnectionStateEnum = {
  ACTIVE: 'active',
  ACCESS_REVOKED: 'access_revoked',
  MISSING_SCOPE: 'missing_scope'
} as const;

export interface ICreateXeroConnectionResponse {
  id: string;
  created: string;
  state: EnumValues<typeof XeroConnectionStateEnum>;
}

export interface ICreateXeroTenantConnectionResponse {
  id: string;
  name: string;
  accountId?: string | null;
  businessId?: string | null;
}

export interface IGetXeroTenantResponse {
  id: string;
  name: string;
  accountId?: string | null;
  businessId?: string | null;
}

export const XeroTenantFeedStateEnum = {
  ACTIVE: 'active',
  PAUSED: 'paused'
} as const;
export interface IXeroTenantFeedResponse {
  id: string;
  tenantId: string;
  walletId: string;
  lastSync: string;
  state: EnumValues<typeof XeroTenantFeedStateEnum>;
}

export interface ICreateXeroFeedRequest {
  walletId: string;
  syncStartDate: string;
}

export interface IGetTenantByAccountIdResponse {
  state: EnumValues<typeof XeroConnectionStateEnum>;
  tenantId: string;
  tenantName: string;
  customerId: string;
  customerName: string;
}
